import api from "./axiosClient";

export const getEmployees = async () => {
    const res = await api.get("/salary/employees");
    return res.data;
};

export const getSalaryList = async () => {
    const res = await api.get("/salary");
    return res.data;
};

export const createSalary = async (payload) => {
    const res = await api.post("/salary", payload);
    return res.data;
};

export const updateSalary = async (id, payload) => {
    const res = await api.put(`/salary/${id}`, payload);
    return res.data;
};

export const getSalaryHistory = async (uid) => {
    const res = await api.get(`/salary/history/${uid}`);
    return res.data;
};